import React, {Component} from "react";
import {ReactComponent as SearchSVG} from "../../images/search-solid.svg";

export default class EditBoardCompliance extends Component{
    state = {
        hovered: false,
    }
    onMouseEnter(){
        this.setState({hovered:true})
    }
    onMouseLeave(){
        this.setState({hovered:false})
    }
    handleInputChange(event) {
        this.setState({fieldInput: event.target.value});
    }
    deleteCompliance(){
        let board = this.props.board;
        let compliance = this.props.compliance;
        let places = [];
        for(let c of board.complianceArray){
            if(c.lat === compliance.lat && compliance.lon === c.lon && c.name === compliance.name){
            }else{
                places.push(c);
            }
        }
        board.complianceArray = places;
        this.props.updateBoard(board);
        //     ,function (){
        //     this.setState({deleted:true})
        // }.bind(this), function (err){
        //     this.setState({deletedError:err})
        // }.bind(this))
    }
    render(){
        console.log(this.props.board);
        let compliance = this.props.compliance
        console.log(this.props.compliance);
        return <div className="compliance-issue-container"
                    onMouseEnter={()=>this.onMouseEnter()}
                    onMouseLeave={()=>this.onMouseLeave()}>
            {/*{(()=>{*/}
            {/*    if(this.state.deleted){*/}
            {/*        return <p className={"green-txt"}>Deleted!</p>*/}
            {/*    }else if(this.state.deletedError){*/}
            {/*        return <p className={"red-txt"}>Unable to Delete: {this.state.deletedError.toString()}</p>*/}
            {/*    }else{*/}
            {/*        return <>*/}
                        <div className="compliance-left">
                            <div className="compliance-name">{compliance.name}</div>
                            <div className="compliance-category">{compliance.category}</div>
                        </div>
                        <div className="compliance-distance">{PrettyDistance(compliance.distance)}Mi
                            {(() => {
                                let c = compliance
                                if(c["place_id"]){
                                    return <a target={"_blank"} rel="noreferrer" href={"https://www.google.com/maps/place/?q=place_id:"+c["place_id"]} className={"to-maps-btn"}>
                                        <SearchSVG/>
                                    </a>
                                }else if(c["address"]){
                                    return <a target={"_blank"} rel="noreferrer" href={"https://www.google.com/maps/place/?q="+c["address"]} className={"to-maps-btn"}>
                                        <SearchSVG/>
                                    </a>
                                }else{
                                    return <a target={"_blank"} rel="noreferrer" href={`https://www.google.com/maps/place/?q=${c.lat},${c.lon}`} className={"to-maps-btn"}>
                                        <SearchSVG/>
                                    </a>
                                }
                            })()}
                        </div>
                        {this.state.hovered ? <span onClick={()=>this.deleteCompliance()} className={"close-icon"}/> : <></>}
                    {/*</>*/}
                {/*}*/}
            {/*})()}*/}
        </div>
    }
}
function PrettyDistance(i) {
    let f = i * 3.28084;
    if(f < 1000){
        return  Math.round(f) + "Ft";
    }
    let m = i * 0.000621371192;
    //if under 1k feet return feet
    return Math.round(m * 100) / 100 +"Mi"
}
